"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuCard = exports.GetTestIdValues = void 0;
var NavigationStyles = _interopRequireWildcard(require("./NavigationStyles"));
var _HeaderAd = _interopRequireDefault(require("../HeaderAd/HeaderAd"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _debounce = require("../../utils/performance/debounce");
var _array = require("../../utils/type-checks/array");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _Navigation = require("./Navigation");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  GetTestIdValues = testId => {
    return {
      componentTestId: testId ? testId : undefined,
      buttonTestId: testId ? `${testId}_button` : undefined,
      menuTestId: testId ? `${testId}_popper` : undefined,
      adTestId: testId ? `${testId}_ad-block` : undefined
    };
  },
  MenuCard = props => {
    const {
        customMenuCardStyles = {},
        customTheme = {},
        fragmentId,
        testId
      } = props,
      theme = merge((0, _styles.useTheme)(), customTheme),
      defaultMenuCardStyles = NavigationStyles.DefaultMenuCardStyes(theme),
      menuCardStyles = merge(defaultMenuCardStyles, customMenuCardStyles);
    return /*#__PURE__*/_react.default.createElement(_material.Card, {
      "data-testid": testId,
      sx: menuCardStyles,
      className: "navigation__menu-card"
    }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
      id: fragmentId
    }));
  };

/**
	 * Desktop Navigation - MegaNav Popper Panel, used in Category Menu List
	 *
	 * @visibleName Desktop Navigation - MegaNav Panel
	 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
	*/
exports.MenuCard = MenuCard;
exports.GetTestIdValues = GetTestIdValues;
const CategoryPanel = props => {
  if (!(0, _object.isObject)(window.PubSub)) {
    window.PubSub = require("pubsub-js");
  }
  const {
      ad,
      autoOpen = false,
      buttonId = "navigation__menu-button-id",
      customButtonStyles = {},
      customPopperBoxStyles = {},
      customPopperStyles = {},
      customTheme = {},
      defaultAnchorId,
      item,
      menuId = "navigation__menu-id",
      testId,
      ...rest
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    {
      label,
      value,
      fragments,
      ad: panelAd,
      path
    } = item,
    adData = (0, _object.isObject)(panelAd) ? panelAd : ad,
    [anchorEl, setAnchorEl] = (0, _react.useState)(null),
    [isAutoOpen, setIsAutoOpen] = (0, _react.useState)(autoOpen),
    defaultButtonStyles = NavigationStyles.DefaultButtonStyles(theme),
    defaultPopperBoxStyles = NavigationStyles.DefaultPopperBoxStyles(theme),
    defaultPopperStyles = NavigationStyles.DefaultPopperStyles(theme),
    buttonStyles = merge(defaultButtonStyles, customButtonStyles),
    popperBoxStyles = merge(defaultPopperBoxStyles, customPopperBoxStyles),
    popperStyles = merge(defaultPopperStyles, customPopperStyles),
    buttonClass = (0, _classnames.default)({
      "popper__button": true,
      "popper__button--isSelected": anchorEl
    }),
    shadow = document.createElement("div"),
    testIdMap = GetTestIdValues(testId),
    handleClick = e => {
      const clickElement = (0, _string.isStringOfLength)(defaultAnchorId) ? document.getElementById(defaultAnchorId) : e.currentTarget;
      return (0, _Navigation.HandleClick)(clickElement, anchorEl, setAnchorEl);
    },
    handleClose = () => (0, _Navigation.HandleClose)(setAnchorEl);
  (0, _react.useEffect)(() => {
    shadow.className = "navigation__shadow";
    shadow.setAttribute("role", "presentation");
    shadow.setAttribute("aria-owns", buttonId);
    if (anchorEl) {
      document.body.appendChild(shadow);
    } else {
      shadow.parentNode?.removeChild(shadow);
    }
    const token = window.PubSub.subscribe("menu.close", handleClose);
    return () => {
      shadow.parentNode?.removeChild(shadow);
      window.PubSub.unsubscribe(token);
    };
  }, [buttonId, anchorEl, shadow]);
  (0, _react.useEffect)(() => {
    const handleResize = (0, _debounce.debounce)(() => {
      if (anchorEl && window.innerWidth < theme.breakpoints.values.md) {
        handleClose();
      }
    }, 50);
    if (isAutoOpen && !anchorEl && (0, _string.isStringOfLength)(defaultAnchorId) && document.getElementById(defaultAnchorId)) {
      setAnchorEl(document.getElementById(defaultAnchorId));
      setIsAutoOpen(false);
    } else {
      handleResize();
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [anchorEl, defaultAnchorId, isAutoOpen, setAnchorEl, theme.breakpoints.values.md]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _string.isStringOfLength)(path) ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testIdMap.componentTestId,
    sx: popperBoxStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: buttonClass,
    "data-testid": testIdMap.buttonTestId,
    id: buttonId,
    to: path,
    sx: buttonStyles,
    component: _reactRouterDom.Link,
    variant: "text"
  }, label)) : /*#__PURE__*/_react.default.createElement(_material.ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testIdMap.componentTestId,
    sx: popperBoxStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    "aria-controls": Boolean(anchorEl) ? menuId : undefined,
    "aria-expanded": Boolean(anchorEl).toString(),
    "aria-haspopup": "true",
    className: buttonClass,
    "data-testid": testIdMap.buttonTestId,
    id: buttonId,
    onClick: handleClick,
    sx: buttonStyles,
    value: value,
    variant: "text"
  }, label), /*#__PURE__*/_react.default.createElement(_material.Popper, {
    anchorEl: anchorEl,
    "aria-owns": buttonId,
    "data-testid": testIdMap.menuTestId,
    id: menuId,
    open: Boolean(anchorEl),
    onClose: handleClose,
    popperOptions: {
      strategy: "fixed"
    },
    sx: popperStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    "aria-label": "Navigation Dropdown Menu",
    component: "nav"
  }, (0, _array.isArrayOfLength)(fragments) && fragments.map((fragmentId, i) => {
    return /*#__PURE__*/_react.default.createElement(MenuCard, _extends({
      customTheme: customTheme,
      key: `menu-card__${value}--${i}`,
      fragmentId: fragmentId
    }, rest));
  }), (0, _string.isStringOfLength)(adData?.adFragmentId) && /*#__PURE__*/_react.default.createElement(_HeaderAd.default, {
    customTheme: customTheme,
    customClassNames: adData.adClassNames || "",
    customCardStyles: adData.adStyles || {},
    testId: testIdMap.adTestId
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: adData.adFragmentId
  })))))));
};
CategoryPanel.propTypes = {
  /** Object describing category-level ad properties */
  ad: _propTypes.default.shape({
    /** Fragment ID to ad content */
    adFragmentId: _propTypes.default.string.isRequired,
    /** Classname(s) for ad */
    adClassNames: _propTypes.default.string,
    /** Custom styles object for ad */
    adStyles: _propTypes.default.shape({
      /** Background Color */
      backgroundColor: _propTypes.default.string,
      /** Background Image */
      backgroundImage: _propTypes.default.string
    })
  }),
  /** Boolean for opening/closing menu on render (Default Value: false) */
  autoOpen: _propTypes.default.bool,
  /** ID Value for button (Default Value: "navigation__menu-button-id") */
  buttonId: _propTypes.default.string,
  /** Custom styles object for menu button (Default Value: {}) */
  customButtonStyles: _propTypes.default.object,
  /** Custom styles object for box component inside popper window (Default Value: {}) */
  customPopperBoxStyles: _propTypes.default.object,
  /** Custom styles object for popper MegaNav window (Default Value: {}) */
  customPopperStyles: _propTypes.default.object,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /* Anchor ID for MegaNav panel positioning */
  defaultAnchorId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  /** Item object describing MegaNav menu properties */
  item: _propTypes.default.shape({
    /** Array of navigation fragment IDs */
    fragments: _propTypes.default.arrayOf(_propTypes.default.string),
    /** Label for Menu Button */
    label: _propTypes.default.string,
    /** Unique string for internal state */
    value: _propTypes.default.string,
    /** Object describing panel-specific ad properties */
    ad: _propTypes.default.shape({
      /** Fragment ID for panel add */
      adFragmentId: _propTypes.default.string.isRequired,
      /** Custom classname(s) */
      adClassNames: _propTypes.default.string,
      /** Custom styles object for panel-specific ad */
      adStyles: _propTypes.default.shape({
        /** Background Color */
        backgroundColor: _propTypes.default.string,
        /** Background Image */
        backgroundImage: _propTypes.default.string
      })
    }),
    /**Optional path for menu links */
    path: _propTypes.default.string
  }).isRequired,
  /** Menu Id String (Default Value: "navigation__menu-id") */
  menuId: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};
MenuCard.propTypes = {
  customMenuCardStyles: _propTypes.default.object,
  customTheme: _propTypes.default.object,
  fragmentId: _propTypes.default.string.isRequired,
  testId: _propTypes.default.string
};
var _default = exports.default = CategoryPanel;